/* @flow */
import config from '../../constants/Config';

export const FUEL_TRANSACTION_LIST_PREF_KEY = 'fleetLocate.fuelTransactionList';
export const getURL = () => {
    const url = `${config.get('FLEET_SERVICES_URL')}/api/fuel-transactions`;
    return url;
};
